<template>
  <div class="page">
    <home-header activeIndex="2" pageTitle="报名查看" />
    <div class="lookWrap">
      <!-- 报名结果 -->
      <div class="card" v-if="flagSignUpResults">
        <div class="modelTitle">
          <div>
            <img :src="require('@/assets/home/icon5.png')" alt="" />
            报名结果
          </div>
        </div>
        <!-- v-if="flagSignUpResults" -->
        <div>
          <div
            class="inner"
            v-if="status == '4' || status == '6' || status == '7'"
          >
            <div class="tit" v-if="flagDownload">
              恭喜您！您提交的报名申请已通过审核，请在下方下载相关文件。
            </div>
            <div class="tit" v-else>恭喜您！您的报名申请已通过审核。</div>
            <div class="desc" v-if="sRemark">备注说明：{{ sRemark }}</div>
            <div class="down" v-if="!flagDownload">文件下载暂未开启。</div>
            <!-- 文件下载 -->
            <div class="down" v-if="flagDownload">
              <div class="tip">
                备注：点击下载，进入页面点击左上角pdf图标进行下载。
              </div>
              <div class="item" v-for="(item, index) in linkList" :key="index">
                <div class="label">《{{ item.uName }}》</div>
                <div class="dashed"></div>
                <div
                  class="btn"
                  @click="count(`${item.templateId}`, item.uName)"
                >
                  下载
                </div>
              </div>
            </div>
          </div>
          <div class="inner" v-if="status == '5'">
            <div class="tit" v-if="flagReturnUpdate">
              您的报名已退回，请<span @click="toUpdate(4)">修改填报信息</span
              >后重新提交报名
            </div>
            <div class="tit" v-else>您的报名已退回</div>
            <div class="desc" v-if="sRemark">备注说明：{{ sRemark }}</div>
          </div>
          <div class="noData" v-if="status == '0' || status == '1'">
            <img :src="require('@/assets/home/no.png')" alt="" />
            <div class="word">您未填写报名信息</div>
          </div>
          <div class="noData" v-if="status == '2'">
            <img :src="require('@/assets/home/no.png')" alt="" />
            <div class="word">您未进行资料回传</div>
          </div>
          <div class="noData" v-if="status == '3'">
            <img :src="require('@/assets/home/no.png')" alt="" />
            <div class="word">审核中，暂无结果</div>
          </div>
          <!-- 获奖情况 flagSignUpResults-->
          <div class="honor" v-if="msStatus">
            <div class="box">
              <div class="title">获奖情况：</div>
              <div class="" v-if="msStatus == 1">
                <a-icon
                  class="icon"
                  style="color: #ffa84d"
                  type="exclamation-circle"
                  theme="filled"
                />
                <span>审核中，暂无结果</span>
              </div>
              <div class="" v-if="msStatus == 2">
                <a-icon
                  class="icon"
                  type="check-circle"
                  style="color: #1ab933"
                  theme="filled"
                />
                <span>已通过</span>
              </div>
              <div class="" v-if="msStatus == 3">
                <a-icon
                  class="icon"
                  style="color: #ffa84d"
                  type="exclamation-circle"
                  theme="filled"
                />
                <span v-if="flagReturnUpdate"
                  >您的获奖资料已退回，请
                  <span class="update" @click="toUpdate(3)">修改</span
                  >后重新提交</span
                >
                <span v-else>您的获奖资料已退回</span>
              </div>
              <div class="" v-if="msStatus == 4">
                <a-icon
                  class="icon"
                  type="close-circle"
                  style="color: #fe4646"
                  theme="filled"
                />
                <span>审核未通过</span>
              </div>
            </div>
            <div class="desc" v-if="msRemark">备注说明：{{ msRemark }}</div>
          </div>
        </div>
        <div class="noData" v-if="!status">
          <img :src="require('@/assets/home/no.png')" alt="" />
          <div class="word">暂无结果</div>
        </div>
        <div class="arrivalAction" v-if="showArrivalIntentEntry">
          <a-button type="primary" size="small" class="arrivalBtn" @click="toArrivalIntent">
            报到意向确认
          </a-button>
        </div>
      </div>
      <!-- 成绩查询 -->
      <div class="card scoreBox" v-if="flagScore">
        <div class="modelTitle">
          <div>
            <img :src="require('@/assets/home/icon6.png')" alt="" />
            成绩查询
          </div>
          <div class="total" v-if="totalScore">
            <span v-if="totalScoreShow == 1 || zbToalScoreShow == 1"
              >总分：
            </span>
            <span v-if="totalScoreShow == 1"> {{ formatScore(totalScore, zbToalScoreFormat) }}</span
            ><span v-if="zbToalScoreShow == 1 && totalScoreShow == 1">/</span>
            <span v-if="zbToalScoreShow == 1">
              {{ formatScore(scoreTotalZb, zbToalScoreFormat) }}
                <span style="font-size: 20px">
                ({{ zbToalScoreBm != "" ? zbToalScoreBm : "占比分" }})
                </span>
            </span>
          </div>
        </div>
        <div
          style="color: red; font-size: 20px"
          v-if="flagScore && sMs == 1 && scoreList.length == 0"
        >
          免试
        </div>
        <div v-else>
          <div class="inner" v-if="scoreList.length > 0">
            <div
              class="itemScore"
              v-for="(item, index) in scoreList"
              :key="index"
            >
              <div>
                {{ item.eSubject
                }}<span v-if="item.tagScoreZb && subjectZbScoreShow == 1"
                  >（{{ item.tagScoreZb }}%）</span
                >
              </div>

              <div class="dashed"></div>
              <div style="display: flex">
                <span v-if="subjectSocreShow == 1">{{ item.esScore }}</span>
                <span v-if="zbSubjectScoreShow == 1 && subjectSocreShow == 1">
                  /</span
                >
                <span v-if="zbSubjectScoreShow == 1"
                  >{{ formatScore(item.zbScore, zbSubjectScoreFormat) }} (占比分)</span
                >
                <!-- 备注 -->
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>{{ item.bz }}</span>
                  </template>
                  <div class="tip" v-if="subjectSorecDescShow == 1 && item.bz">
                    备注
                  </div>
                </a-tooltip>
              </div>
            </div>
          </div>
          <div class="noData" v-else>
            <img :src="require('@/assets/home/no.png')" alt="" />
            <div class="word">暂无数据</div>
          </div>
          <div class="lqfscx" v-if="lqScoreShow == 1" @click="toFractionSearch">
            录取分数线查询
          </div>
        </div>
      </div>
      <!-- 录取结果 -->
      <div class="card result" v-if="lqFlag">
        <div class="modelTitle">
          <div>
            <img :src="require('@/assets/home/icon7.png')" alt="" />
            录取结果
          </div>
        </div>
        <div v-if="lqFlag">
          <div class="inner" v-if="status == '6'">
            <div class="title" v-if="lqtips">{{ lqtips }}</div>
            <div class="title" v-else>
              恭喜您！您已被我校预录取（正式录取以招办下发的录取数据为准），请等待录取通知书的发放以及后续学习的安排。
            </div>
            <!-- <div class="desc" v-if="lqRemark">备注说明：{{ lqRemark }}</div> -->
          </div>
          <div class="inner" v-else-if="status == '7'">
            <div class="title" v-if="lqtips">{{ lqtips }}</div>
            <div class="title" v-else>抱歉！您未被我校录取。</div>
            <!-- <div class="desc" v-if="lqRemark">备注说明：{{ lqRemark }}</div> -->
          </div>
          <div class="inner" v-else>
            <div class="title">招生工作正在进行中，还未公布预录取结果。</div>
          </div>
          <div class="lqzy" v-if="lqzy && status == '6'">
            录取专业：<span>{{ lqzy }}</span>
          </div>
          <div class="desc" v-if="lqRemark">备注说明：{{ lqRemark }}</div>
        </div>
        <div class="noData" v-else>
          <img :src="require('@/assets/home/no.png')" alt="" />
          <div class="word">暂无结果</div>
        </div>
      </div>

      <div class="card scoreBox" style="background: transparent;" v-if="!flagScore || !lqFlag || !flagSignUpResults">
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import moment from 'moment'
import { queryStatu, GradeDetail } from '@/api/look'
import { getFlag } from '@/api/common'
import HomeHeader from '@/components/HomeHeader'
import Footer from '@/components/footer'
import { formatScore } from '@/utils/scoreFormat'

export default {
  name: 'singUpLook',
  components: {
    HomeHeader,
    Footer
  },
  data () {
    return {
      flagSignUpResults: false, // 报名结果
      flagScore: false, // 成绩
      flagDownload: false, // 证件下载
      lqFlag: false, // 录取结果
      flagReturnUpdate: false, // 退回是否可修改
      linkList: [],
      scoreList: [],
      totalScore: '',
      scoreTotalZb: '',
      lqtips: '',
      lqzy: '',
      status: '', // 学生报名状态( 0 信息导入 1 注册账号 2 信息确认，3 待审核，4通过， 5 退回  6 已录取，7 未录取)
      sRemark: '',
      lqRemark: '',
      msStatus: '', // 面试资料审核状态 1 待审核  2 通过 3退回 4 不通过
      msRemark: '', // 面试资料审核备注
      sMs: '', // 是否面试
      scode: localStorage.getItem('sCode'),
      iszb: false, // 占比
      lqScoreShow: '',
      totalScoreShow: '',
      zbToalScoreShow: '',
      subjectSocreShow: '',
      zbSubjectScoreShow: '',
      subjectZbScoreShow: '',
      subjectSorecDescShow: '',
      zbToalScoreBm: '',
      totalScoreFormat: '',
      zbToalScoreFormat: '',
      zbSubjectScoreFormat: '',
      userInfo: JSON.parse(localStorage.getItem('user')),
      hasArrivalIntentAuth: false,
      showArrivalIntentEntry: false
    }
  },
  filters: {
    dateFilter (val) {
      return moment(+val).format('YYYY-MM-DD')
    }
  },
  methods: {
    formatScore,
    updateArrivalIntentEntry () {
      this.showArrivalIntentEntry =
        this.hasArrivalIntentAuth && String(this.status) === '6'
    },
    toUpdate (curTab) {
      this.$router.push({
        path: '/singUp',
        query: {
          curTab: curTab
        }
      })
    },
    toFractionSearch () {
      this.$router.push({
        path: '/fractionLook'
      })
    },
    toArrivalIntent () {
      this.$router.push({
        path: '/arrivalIntent'
      })
    },
    initArrivalIntentAuth () {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      let hasAuth = false
      if (userInfo && userInfo.menuList) {
        userInfo.menuList.forEach((menu) => {
          if (menu.mcode === 'arrivalIntent') {
            hasAuth = true
          }
        })
      }
      this.hasArrivalIntentAuth = hasAuth
      this.updateArrivalIntentEntry()
    },
    count (templateId, uName) {
      window.open(
        `/welcome/publish/moblie/recruit/get/generateDownload?sId=${this.userInfo.sid}&templateId=${templateId}`
      )

      // 保存操作记录
      const ids = []
      const user = JSON.parse(localStorage.getItem('user'))
      ids.push(user.sid.toString())
      const params = { operation: uName + '下载', stuIds: ids }
      saveLog(params)
    },
    getFlagAll () {
      // 报名结果
      getFlag({
        paramKey: 'signUpResults',
        uvCode: localStorage.getItem('uvCode')
      }).then(res => {
        if (res.paramValue == '1') {
          this.flagSignUpResults = true
        } else {
          this.flagSignUpResults = false
        }
      })
      // 证件下载
      // getFlag({
      //   paramKey: "download",
      //   uvCode: localStorage.getItem('uvCode')
      // }).then(res => {
      //   if (res.paramValue == '1') {
      //     this.flagDownload = true;
      //   } else {
      //     this.flagDownload = false;
      //   }
      // })
      // 成绩查询
      getFlag({
        paramKey: 'score',
        uvCode: localStorage.getItem('uvCode')
      }).then((res) => {
        if (res.paramValue == '1') {
          this.flagScore = true
        } else {
          this.flagScore = false
        }
      })
      // 录取结果
      getFlag({
        paramKey: 'acceptanceResults',
        uvCode: localStorage.getItem('uvCode')
      }).then((res) => {
        if (res.paramValue == '1') {
          this.lqFlag = true
        } else {
          this.lqFlag = false
        }
      })
      // 退回是否可修改
      getFlag({
        paramKey: 'returnUpdate',
        uvCode: localStorage.getItem('uvCode')
      }).then((res) => {
        const date = new Date().getTime()

        if (res.paramValue == '1') {
          if (res.opentime && res.closetime) {
            if (date >= res.opentime && date <= res.closetime) {
              this.flagReturnUpdate = true
            } else {
              this.flagReturnUpdate = false
            }
          } else {
            this.flagReturnUpdate = true
          }
        } else {
          this.flagReturnUpdate = false
        }
      })
    },
    queryStatu () {
      queryStatu({
        scode: localStorage.getItem('sCode')
      }).then((res) => {
        if (res.data) {
          this.status = res.data.recruit ? res.data.recruit.sStatus : ''
          this.sRemark = res.data.recruit ? res.data.recruit.sRemark : ''
          this.msStatus = res.data.recruit ? res.data.recruit.msStatus : ''
          this.msRemark = res.data.recruit ? res.data.recruit.msRemark : ''
          this.lqRemark = res.data.recruit ? res.data.recruit.lqRemark : ''
          this.sMs = res.data.recruit ? res.data.recruit.sMs : ''
          if (res.data.bbls) {
            this.linkList = res.data.bbls
          }
          if (res.data.stuScores) {
            this.scoreList = res.data.stuScores
          }
          if (this.linkList.length > 0) {
            this.flagDownload = true
          }
          this.lqzy = res.data.lqzy
          this.lqtips = res.data.lqtips
          this.totalScore = res.data.scoreTotal
          this.scoreTotalZb = res.data.scoreTotalZb
          this.lqFlag = res.data.lqFlag
          this.flagScore = res.data.scoreFlag
          this.iszb = res.data.iszb
          this.updateArrivalIntentEntry()
        }
      })
    }
  },
  mounted () {
    this.initArrivalIntentAuth()
    this.getFlagAll()
    this.queryStatu()
    GradeDetail().then((res) => {
      this.lqScoreShow = res.lqScoreShow
      this.totalScoreShow = res.totalScoreShow
      this.totalScoreFormat = res.totalScoreFormat || '5'
      this.zbToalScoreShow = res.zbToalScoreShow
      this.zbToalScoreFormat = res.zbToalScoreFormat || '5'
      this.subjectSocreShow = res.subjectSocreShow
      this.zbSubjectScoreShow = res.zbSubjectScoreShow
      this.zbSubjectScoreFormat = res.zbSubjectScoreFormat || '5'
      this.subjectZbScoreShow = res.subjectZbScoreShow
      this.subjectSorecDescShow = res.subjectSorecDescShow
      this.zbToalScoreBm = res.zbToalScoreBm || ''
    })
  }
}
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.lookWrap {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 20px auto 50px;
  .card {
    width: 388px;
    min-height: 335px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 16px 16px 12px;
  }
  .modelTitle {
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5f5f5;
    img {
      margin-right: 4px;
    }
    .total {
    }
  }
  .arrivalAction {
    margin-top: 18px;
    display: flex;
    justify-content: center;
  }
  .arrivalBtn {
    height: 30px;
    padding: 0 12px;
    border-radius: 4px;
  }
  .noData {
    margin: 0 auto;
    padding: 64px 0 0;
    text-align: center;
    .word {
      font-size: 12px;
      color: #999;
      margin-top: 18px;
    }
  }
  .tit {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 8px 0 4px;
    text-indent: 2em;
    span {
      color: #2a79ff;
      text-decoration: underline;
    }
  }
  .desc {
    font-size: 12px;
    color: #999;
    // text-indent: 2em;
  }
  .down {
    margin-top: 16px;
    .tip {
      color: #ff5252;
      font-size: 12px;
    }
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 16px 0;
      color: #666;
      font-size: 14px;
      .label {
        max-width: 200px;
      }
      .dashed {
        flex-grow: 1;
        border-top: 1px dashed #d6d6d6;
        margin: 0 8px;
      }
      .btn {
        font-size: 12px;
        color: #2a79ff;
        border: 1px solid #2a79ff;
        padding: 1px 7px 0px 7px;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }
  .honor {
    margin-top: 16px;
    .box {
      display: flex;
    }
    .title {
      font-weight: 600;
      font-size: 14px;
      color: #333333;
    }
    .icon {
      margin-right: 6px;
      font-size: 16px;
    }
    span {
      font-size: 14px;
      color: #666666;
    }
    .update {
      color: #2a79ff;
      text-decoration: underline;
    }
  }
  .scoreBox {
    .itemScore {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 16px 0;
      color: #666;
      font-size: 14px;
      span {
        color: #999;
      }
      .dashed {
        flex-grow: 1;
        border-top: 1px dashed #d6d6d6;
        margin: 0 8px;
      }
    }
    .tip {
      color: #ff5252;
      font-size: 14px;
    }
  }
  .result {
    text-align: left;
    .title {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      padding: 8px 0 4px;
      text-indent: 2em;
    }
    .desc {
      font-size: 12px;
      color: #999;
      // text-indent: 2em;
    }
    .lqzy {
      margin-top: 16px;
      font-size: 14px;
      color: #666;
      span {
        color: #333;
        font-weight: 600;
      }
    }
  }
}
.lqfscx {
  color: #1890ff;
  text-align: center;
  margin: 20px 0;
  font-size: 16px;
  cursor: pointer;
}
</style>
